import { RetryButton } from './RetryButton';

/**
 * A read that failed, said plainly, with the way to try again (spec 126
 * FR-009). One component so every page and panel fails the same way, and so
 * a failure is never mistaken for an empty list (FR-010).
 */
export function ReadFailure({
  message,
  onRetry,
  isFetching = false,
  testId,
}: {
  /** The whole sentence: "The comments could not be loaded." */
  message: string;
  onRetry: () => void;
  isFetching?: boolean;
  testId?: string;
}) {
  return (
    <div
      role="alert"
      data-testid={testId}
      className="text-muted-foreground flex flex-wrap items-center gap-x-3 gap-y-2 text-sm"
    >
      <p>{message}</p>
      <RetryButton onRetry={onRetry} isFetching={isFetching} />
    </div>
  );
}
